import { CookieService } from '@/services/cookie'
import { buildAbsoluteSpaPathForRedirect } from '@spa/router/hooks/lib/build-absolute-spa-path-for-redirect'
import { Route } from 'vue-router'

/*
 * カート認証画面へ遷移する時の事前ガード.
 *
 * 事前ログインが必要なページXへアクセスした時、X側の判断でカート認証画面へリダイレクトされる場合がある(ex. 注文確認画面).
 *
 * このhookでは、上記のようなルートでカート認証画面へアクセスした時に from クエリパラメータで遷移元ページを保持させることで、
 * ログイン・登録後にリダイレクトされるパスを「カート認証画面へのリダイレクト元」であるXへと固定する.
 *
 * そもそも認証済みで、カート認証画面を経由させる必要が無いにも関わらずこの画面へ遷移してきた時は、
 * 遷移元であるXへと送り返す.
 */

export const propsForCartLogin = (route: Route) => {
  const { from } = route.query

  return {
    next: buildAbsoluteSpaPathForRedirect(from),
    signupLink: '/cart/signup',
    title: '会員登録/ログイン',
  }
}
export const propsForCartSignup = (route: Route) => {
  const { from } = route.query

  return {
    next: buildAbsoluteSpaPathForRedirect(from),
    loginLink: '/cart/login',
    title: '会員登録して購入する',
  }
}

export type RouteTo = Pick<Route, 'query'>
export type RouteFrom = Pick<Route, 'query'>

export function beforeEnterCartAuth(to: RouteTo, from: RouteFrom, next): void {
  if (to.query.from === undefined) {
    // 遷移元をクエリパラメータとして保持するようにすることで、
    // カート内認証(ログイン or 会員登録)した後のリダイレクト先をそれまでの遷移ルートに応じて動的に決定可能にする.
    // 上書きするとカート内認証間での遷移などで遷移元情報が消えてしまうので、既にクエリパラメータが指定されている場合は更新せず維持.
    const query = { ...to.query, from: from.query.from || '/' }

    return next({ ...to, query })
  }

  if (CookieService.isRegistered()) {
    const query = to.query
    const { from: nextPath, ...otherQuery } = query
    next({
      ...to,
      path: nextPath,
      query: otherQuery,
    })

    return
  }

  return next()
}
